import React, { memo, useState, useEffect } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  InputGroup,
  InputGroupAddon,
  Label,
  Form,
  FormGroup,
  Row,
  Col,
} from "reactstrap";
import DatePicker from "react-datepicker";
import moment from "moment";
import IntlMessages from "../../../helpers/IntlMessages";
import PerfectScrollbar from "react-perfect-scrollbar";

import axios from "axios";
import { END_POINT } from "../../../constants/defaultValues";
import { AddCommaNumber, CleanPrice, generateStockSku, NotificatioSucController } from "../../../helpers/Utils";
import PriceInput from "../../../components/common/PriceInput";
import DynamicForm from "../general/DynamicForm";
import { Colxx } from "../../../components/common/CustomBootstrap";
import Select from "react-select";
import Creatable from "../../../components/common/CreatableSelect";
import BarcodeScanner from "../../../components/common/BarcodeScanner";

const ContentComponent = ({
  title,
  isOpen,
  toggle,
  onSubmit,
  data_dynamic_form,
  values,
  setting,
  onChange,
  onReset,
  data_providers,
  categoryOptions = [],
  warehouseOptions = [{ label: "Kho chính", value: "Kho chính" }],
  brandOptions = [],
  onChangeDynamicForm,
}) => {
  const [isBarcodeScannerOpen, setIsBarcodeScannerOpen] = useState(false);

  const lookupTemplateByBarcode = async (barcodeVal) => {
    const code = String(barcodeVal || "").trim();
    if (!code) return;
    try {
      const token = localStorage.getItem("access_token");
      const res = await axios.get(
        `${END_POINT}/product-template/lookup/${encodeURIComponent(code)}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (res.data && res.data.found && res.data.data) {
        const item = res.data.data;
        NotificatioSucController(`Tìm thấy sản phẩm mẫu: ${item.name}`);
        if (!values.name && item.name && typeof onChange === "function") {
          onChange(item.name, "name");
        }
        if (!values.unit && item.sale_unit && typeof onChange === "function") {
          onChange(item.sale_unit, "unit");
        }
        if ((!values.unit_price || Number(values.unit_price) === 0) && item.suggested_cost_price && typeof onChange === "function") {
          onChange(String(Math.round(Number(item.suggested_cost_price))), "unit_price");
        }
        if (!values.brand_name && item.brand_name && typeof onChange === "function") {
          onChange(item.brand_name, "brand_name");
        }
        if (!values.category_name && item.category_name && typeof onChange === "function") {
          onChange(item.category_name, "category_name");
        }
      }
    } catch (e) {
      console.warn("Lỗi tra cứu sản phẩm mẫu trong AddStock:", e);
    }
  };

  useEffect(() => {
    if (
      isOpen &&
      (!values?.sku || !String(values.sku).trim()) &&
      typeof onChange === "function"
    ) {
      onChange(generateStockSku(), "sku");
    }
  }, [isOpen, values?.sku, onChange]);

  let items_select = [];
  items_select = data_providers.map((item) => ({
    label: item.name,
    value: item.name,
  }));
  const categoryOptionsSelect = Array.from(
    new Set(
      (categoryOptions || [])
        .map((item) =>
          typeof item === "string" ? item : item?.value || item?.label,
        )
        .filter(Boolean)
        .map((item) => String(item).trim())
        .filter(Boolean),
    ),
  ).map((item) => ({
    label: item,
    value: item,
  }));
  const brandOptionsSelect = Array.from(
    new Set(
      (brandOptions || [])
        .map((item) =>
          typeof item === "string" ? item : item?.value || item?.label,
        )
        .filter(Boolean)
        .map((item) => String(item).trim())
        .filter(Boolean),
    ),
  ).map((item) => ({
    label: item,
    value: item,
  }));
  const warehouseOptionsSelect = Array.from(
    new Set(
      (warehouseOptions || [])
        .map((item) =>
          typeof item === "string" ? item : item?.value || item?.label,
        )
        .filter(Boolean)
        .map((item) => String(item).trim())
        .filter(Boolean),
    ),
  );
  const normalizedWarehouseOptions = (
    warehouseOptionsSelect.length ? warehouseOptionsSelect : ["Kho chính"]
  ).map((item) => ({
    label: item,
    value: item,
  }));
  const selectedWarehouse =
    normalizedWarehouseOptions.find(
      (item) => item.value === (values.warehouse_name || "Kho chính"),
    ) || normalizedWarehouseOptions[0];
  const previewImportValue =
    Number(CleanPrice(values.unit_price)) * Number(values.new_count || 0);

  return (
    <>
      <Modal
        isOpen={isOpen}
        toggle={toggle}
        size="lg"
        // centered
        backdrop="static"
        autoFocus={false}
      >
        <Form onSubmit={(e) => onSubmit(e)}>
          <ModalHeader toggle={toggle}>
            <div className="d-flex align-items-center">
              <span>{title}</span>
            </div>
          </ModalHeader>
          <ModalBody className="py-3 px-4">
            <PerfectScrollbar
              options={{
                suppressScrollX: true,
                wheelPropagation: false,
              }}
              style={{
                maxHeight: "calc(80vh - 130px)",
                overflowX: "hidden",
                paddingRight: "6px",
              }}
            >
              <Row>
                {/* Cột 1: Thông tin nguyên liệu & Phân loại */}
                <Colxx xxs="12" md="6" className="pr-md-3">
                  <div className="d-flex align-items-center mb-3 pb-2 border-bottom">
                    <i
                      className="simple-icon-layers text-primary mr-2 font-weight-bold"
                      style={{ fontSize: "1.1rem" }}
                    />
                    <h6 className="mb-0 font-weight-bold text-primary">
                      Thông tin nguyên liệu
                    </h6>
                  </div>

                  {/* Tên & Đơn vị tính */}
                  <Row>
                    <Colxx xxs="12" sm="8" className="pr-sm-1">
                      <FormGroup className="has-float-label">
                        <Label for="name" className="text-muted">
                          <IntlMessages id="stock.name" />
                          <span style={{ color: "red" }}>*</span>
                        </Label>
                        <Input
                          type="text"
                          name="name"
                          id="name"
                          autoFocus={true}
                          value={values.name}
                          onChange={onChange}
                        />
                      </FormGroup>
                    </Colxx>
                    <Colxx xxs="12" sm="4" className="pl-sm-1">
                      <FormGroup className="has-float-label">
                        <Label for="unit" className="text-muted">
                          <IntlMessages id="stock.unit" />
                        </Label>
                        <Input
                          type="text"
                          name="unit"
                          id="unit"
                          disabled={setting.viewonly && !setting.add}
                          value={values.unit}
                          onChange={onChange}
                        />
                      </FormGroup>
                    </Colxx>
                  </Row>

                  {/* SKU & Barcode */}
                  <Row>
                    <Colxx xxs="12" sm="5" className="pr-sm-1">
                      <FormGroup className="has-float-label">
                        <Label for="sku" className="text-muted">
                          Mã SKU
                        </Label>
                        <Input
                          disabled
                          type="text"
                          name="sku"
                          id="sku"
                          value={values.sku}
                        />
                      </FormGroup>
                    </Colxx>
                    <Colxx xxs="12" sm="7" className="pl-sm-1">
                      <FormGroup className="has-float-label">
                        <Label for="barcode" className="text-muted">
                          Mã Barcode
                        </Label>
                        <InputGroup>
                          <Input
                            type="text"
                            name="barcode"
                            id="barcode"
                            maxLength={30}
                            value={values.barcode || ""}
                            onChange={onChange}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                e.preventDefault();
                                lookupTemplateByBarcode(values.barcode);
                              }
                            }}
                            onBlur={() => {
                              if (values.barcode && !values.name) {
                                lookupTemplateByBarcode(values.barcode);
                              }
                            }}
                            placeholder="Nhập hoặc quét barcode"
                          />
                          <InputGroupAddon addonType="append">
                            <Button
                              color="outline-secondary"
                              type="button"
                              className="px-2"
                              title="Quét mã barcode bằng camera"
                              onClick={() => setIsBarcodeScannerOpen(true)}
                            >
                              <i className="simple-icon-camera" />
                            </Button>
                          </InputGroupAddon>
                        </InputGroup>
                        <small className="text-muted">Nhập/quét mã vạch (tự động nhận diện sản phẩm mẫu)</small>
                      </FormGroup>
                    </Colxx>
                  </Row>

                  {/* Danh mục */}
                  <FormGroup className="has-float-label">
                    <Label for="category_name" className="text-muted">
                      <IntlMessages id="stock.dashboard.category" />
                    </Label>
                    <Creatable
                      name="category_name"
                      id="category_name"
                      placeholder="Chọn hoặc tạo mới danh mục"
                      value={
                        values.category_name
                          ? {
                              label: values.category_name,
                              value: values.category_name,
                            }
                          : null
                      }
                      options={categoryOptionsSelect}
                      isClearable
                      onChange={(selected) =>
                        onChange(
                          selected
                            ? selected.__isNew__
                              ? selected.label
                              : selected.value
                            : "",
                          "category_name",
                        )
                      }
                      formatCreateLabel={(inputValue) =>
                        `Tạo mới danh mục: "${inputValue}"`
                      }
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({
                          ...base,
                          zIndex: 9999,
                        }),
                        placeholder: (base) => ({
                          ...base,
                          fontSize: "0.8rem",
                          color: "#9ca3af",
                          opacity: 0.75,
                        }),
                      }}
                    />
                  </FormGroup>

                  {/* Thương hiệu */}
                  <FormGroup className="has-float-label">
                    <Label for="brand_name" className="text-muted">
                      Thương hiệu
                    </Label>
                    <Creatable
                      name="brand_name"
                      id="brand_name"
                      placeholder="Chọn hoặc tạo mới"
                      value={
                        values.brand_name
                          ? {
                              label: values.brand_name,
                              value: values.brand_name,
                            }
                          : null
                      }
                      options={brandOptionsSelect}
                      isClearable
                      onChange={(selected) =>
                        onChange(
                          selected
                            ? selected.__isNew__
                              ? selected.label
                              : selected.value
                            : "",
                          "brand_name",
                        )
                      }
                      formatCreateLabel={(inputValue) =>
                        `Tạo mới thương hiệu: "${inputValue}"`
                      }
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({
                          ...base,
                          zIndex: 9999,
                        }),
                        placeholder: (base) => ({
                          ...base,
                          fontSize: "0.8rem",
                          color: "#9ca3af",
                          opacity: 0.75,
                        }),
                      }}
                    />
                  </FormGroup>

                  {/* Quy cách đóng gói */}
                  <FormGroup className="has-float-label">
                    <Label
                      for="packing_specification"
                      className="text-muted"
                    >
                      Quy cách đóng gói
                    </Label>
                    <Input
                      type="text"
                      name="packing_specification"
                      id="packing_specification"
                      value={values.packing_specification || ""}
                      onChange={onChange}
                      placeholder="VD: Thùng 24 lon, Bao 25kg..."
                    />
                  </FormGroup>

                  {/* Kho lưu trữ & Trạng thái hoạt động */}
                  <Row>
                    <Colxx xxs="12" sm="6" className="pr-sm-1">
                      <FormGroup className="has-float-label">
                        <Label for="warehouse_name" className="text-muted">
                          <IntlMessages id="stock.dashboard.warehouse" />
                        </Label>
                        <Select
                          name="warehouse_name"
                          id="warehouse_name"
                          className="react-select"
                          classNamePrefix="react-select"
                          value={selectedWarehouse}
                          options={normalizedWarehouseOptions}
                          isClearable={false}
                          onChange={(selected) =>
                            onChange(
                              selected ? selected.value : "Kho chính",
                              "warehouse_name",
                            )
                          }
                          menuPortalTarget={document.body}
                          styles={{
                            menuPortal: (base) => ({
                              ...base,
                              zIndex: 9999,
                            }),
                          }}
                        />
                      </FormGroup>
                    </Colxx>
                    <Colxx xxs="12" sm="6" className="pl-sm-1">
                      <FormGroup className="has-float-label">
                        <Label for="is_active" className="text-muted">
                          Trạng thái hoạt động
                        </Label>
                        <Select
                          name="is_active"
                          id="is_active"
                          className="react-select"
                          classNamePrefix="react-select"
                          value={
                            values.is_active === false ||
                            values.is_active === "false"
                              ? { label: "Ngừng sử dụng", value: false }
                              : { label: "Đang sử dụng", value: true }
                          }
                          options={[
                            { label: "Đang sử dụng", value: true },
                            { label: "Ngừng sử dụng", value: false },
                          ]}
                          isClearable={false}
                          onChange={(selected) =>
                            onChange(
                              selected ? selected.value : true,
                              "is_active",
                            )
                          }
                          menuPortalTarget={document.body}
                          styles={{
                            menuPortal: (base) => ({
                              ...base,
                              zIndex: 9999,
                            }),
                          }}
                        />
                      </FormGroup>
                    </Colxx>
                  </Row>

                  {/* Định mức tồn tối thiểu & Định mức tồn tối đa */}
                  <Row>
                    <Colxx xxs="12" sm="6" className="pr-sm-1">
                      <FormGroup className="has-float-label">
                        <Label for="min_stock_threshold" className="text-muted">
                          <IntlMessages id="stock.dashboard.min-stock-threshold" />
                        </Label>
                        <Input
                          type="number"
                          min="0"
                          step="1"
                          name="min_stock_threshold"
                          id="min_stock_threshold"
                          value={values.min_stock_threshold || 0}
                          onChange={onChange}
                        />
                      </FormGroup>
                    </Colxx>
                    <Colxx xxs="12" sm="6" className="pl-sm-1">
                      <FormGroup className="has-float-label">
                        <Label for="max_stock_threshold" className="text-muted">
                          Định mức tồn tối đa
                        </Label>
                        <Input
                          type="number"
                          min="0"
                          step="1"
                          name="max_stock_threshold"
                          id="max_stock_threshold"
                          value={values.max_stock_threshold || 0}
                          onChange={onChange}
                          placeholder="0 (không giới hạn)"
                        />
                      </FormGroup>
                    </Colxx>
                  </Row>
                </Colxx>

                {/* Cột 2: Thông tin nhập kho & Nhà cung cấp */}
                <Colxx xxs="12" md="6" className="pl-md-3">
                  <div className="d-flex align-items-center mb-3 pb-2 border-bottom">
                    <i
                      className="simple-icon-basket-loaded text-primary mr-2 font-weight-bold"
                      style={{ fontSize: "1.1rem" }}
                    />
                    <h6 className="mb-0 font-weight-bold text-primary">
                      Thông tin nhập kho & NCC
                    </h6>
                  </div>

                  {setting.add ? (
                    <>
                      <Row>
                        <Colxx xxs="12" sm="6" className="pr-sm-1">
                          <FormGroup className="has-float-label">
                            <Label for="unit_price" className="text-muted">
                              <IntlMessages id="stock.unit-price" />
                              <span style={{ color: "red" }}>*</span>
                            </Label>
                            <PriceInput
                              name="unit_price"
                              id="unit_price"
                              value={values.unit_price}
                              onChange={onChange}
                            />
                          </FormGroup>
                        </Colxx>
                        <Colxx xxs="12" sm="6" className="pl-sm-1">
                          <FormGroup className="has-float-label">
                            <Label for="new_count" className="text-muted">
                              <IntlMessages id="stock.count" />
                              <span style={{ color: "red" }}>*</span>
                            </Label>
                            <Input
                              name="new_count"
                              id="new_count"
                              type="number"
                              step="1"
                              value={values.new_count}
                              onChange={onChange}
                            />
                          </FormGroup>
                        </Colxx>
                      </Row>

                      <div className="border rounded px-3 py-2 mb-3 d-flex justify-content-between align-items-center bg-light">
                        <div>
                          <small className="d-block text-muted">
                            Giá trị nhập dự kiến
                          </small>
                          <small className="text-muted">
                            Giá mua x Số lượng nhập
                          </small>
                        </div>
                        <strong className="h6 mb-0 text-primary">
                          {AddCommaNumber(Math.round(previewImportValue || 0))}{" "}
                          đ
                        </strong>
                      </div>

                      <Row>
                        <Colxx xxs="12" sm="6" className="pr-sm-1">
                          <FormGroup className="has-float-label">
                            <Label for="batch_code" className="text-muted">
                              Mã lô
                            </Label>
                            <Input
                              type="text"
                              name="batch_code"
                              id="batch_code"
                              value={values.batch_code || ""}
                              onChange={onChange}
                              placeholder="VD: LOT-2026-001"
                            />
                          </FormGroup>
                        </Colxx>
                        <Colxx xxs="12" sm="6" className="pl-sm-1">
                          <FormGroup className="has-float-label">
                            <Label
                              for="storage_location"
                              className="text-muted"
                            >
                              Vị trí lưu kho
                            </Label>
                            <Input
                              type="text"
                              name="storage_location"
                              id="storage_location"
                              value={values.storage_location || ""}
                              onChange={onChange}
                              placeholder="VD: Kệ A1, tủ mát 2"
                            />
                          </FormGroup>
                        </Colxx>
                      </Row>
                    </>
                  ) : null}

                  {/* Hạn sử dụng */}
                  {setting.add ? (
                    <FormGroup className="has-float-label">
                      <Label for="expiry_date" className="text-muted">
                        Hạn sử dụng (nếu có)
                      </Label>
                      <DatePicker
                        name="expiry_date"
                        id="expiry_date"
                        selected={
                          values.expiry_date ? moment(values.expiry_date) : null
                        }
                        onChange={(date) => onChange(date, "expiry_date")}
                        dateFormat="DD-MM-YYYY"
                        minDate={moment()}
                        placeholderText="DD-MM-YYYY"
                        className="form-control"
                        isClearable
                      />
                    </FormGroup>
                  ) : null}

                  {/* Nhà cung cấp */}
                  <FormGroup className="has-float-label">
                    <Label for="company-provider" className="text-muted">
                      <IntlMessages id="company-provider.name" />
                    </Label>
                    <Creatable
                      placeholder={"Chọn hoặc tạo mới nhà cung cấp"}
                      name="items_selected"
                      id="items_selected"
                      onChange={(val) => onChange(val, "items_selected")}
                      value={values.items_selected}
                      options={items_select}
                      formatCreateLabel={(inputValue) =>
                        `Tạo mới: "${inputValue}"`
                      }
                      isClearable
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({
                          ...base,
                          zIndex: 9999,
                        }),
                      }}
                    />
                  </FormGroup>

                  {/* Hiển thị fields thanh toán khi đã chọn nhà cung cấp */}
                  {setting.add && values.items_selected ? (
                    <Row>
                      <Colxx xxs="6" className="pr-1">
                        <FormGroup className="has-float-label">
                          <Label className="text-muted">Đã trả</Label>
                          <PriceInput
                            name="price_outcome"
                            id="price_outcome"
                            value={values.price_outcome}
                            onChange={onChange}
                          />
                        </FormGroup>
                      </Colxx>
                      <Colxx xxs="6" className="pl-1">
                        <FormGroup className="has-float-label">
                          <Label className="text-muted">Còn nợ</Label>
                          <Input
                            disabled
                            value={AddCommaNumber(
                              Math.max(
                                0,
                                Number(CleanPrice(values.unit_price)) *
                                  Number(values.new_count || 0) -
                                  Number(CleanPrice(values.price_outcome)),
                              ),
                            )}
                          />
                        </FormGroup>
                      </Colxx>
                    </Row>
                  ) : null}

                  {/* Ghi chú nhập kho */}
                  {setting.add ? (
                    <FormGroup className="has-float-label">
                      <Label for="stock_note" className="text-muted">
                        Ghi chú nhập kho
                      </Label>
                      <Input
                        type="textarea"
                        rows="3"
                        name="stock_note"
                        id="stock_note"
                        value={values.stock_note || ""}
                        onChange={onChange}
                        placeholder="Ghi chú tình trạng hàng, lý do nhập..."
                      />
                    </FormGroup>
                  ) : null}

                  {setting.update ? (
                    <>
                      <FormGroup>
                        <Label for="count" className="text-muted">
                          <IntlMessages id="stock.count-current" />
                        </Label>
                        <Row>
                          <Col xs="6">
                            <InputGroup>
                              <Input
                                type="text"
                                name="count"
                                id="count"
                                disabled={true}
                                value={values.count}
                              />
                              <InputGroupAddon addonType="append">
                                {values.unit}
                              </InputGroupAddon>
                            </InputGroup>
                          </Col>
                          <Col xs="6">
                            <Button
                              disabled={setting.viewonly && !setting.add}
                              onClick={() => {
                                onReset(values);
                              }}
                            >
                              <IntlMessages id="stock.reset" />
                            </Button>
                          </Col>
                        </Row>
                      </FormGroup>
                      <FormGroup className="has-float-label">
                        <Label for="total" className="text-muted">
                          <IntlMessages id="stock.count-total" />
                        </Label>
                        <InputGroup>
                          <Input
                            type="text"
                            name="total"
                            id="total"
                            disabled={true}
                            value={values.total}
                          />
                          <InputGroupAddon addonType="append">
                            {values.unit}
                          </InputGroupAddon>
                        </InputGroup>
                      </FormGroup>
                    </>
                  ) : null}
                </Colxx>
              </Row>

              {data_dynamic_form && data_dynamic_form.length > 0 ? (
                <div className="mt-3 pt-3 border-top">
                  <DynamicForm
                    values={values.dynamic_form}
                    data={data_dynamic_form}
                    onChange={onChangeDynamicForm}
                    disabled={setting.viewonly && !setting.add}
                  />
                </div>
              ) : null}
            </PerfectScrollbar>
          </ModalBody>
          <ModalFooter className="d-flex justify-content-end">
            <Button
              color="outline-secondary"
              type="button"
              onClick={toggle}
              className="mr-2"
            >
              <IntlMessages id="general.btn-cancel" />
            </Button>
            <Button color="primary" type="submit">
              <IntlMessages id="stock.btn-add" />
            </Button>
          </ModalFooter>
        </Form>
      </Modal>
      {isBarcodeScannerOpen && (
        <BarcodeScanner
          isOpen={isBarcodeScannerOpen}
          onClose={() => setIsBarcodeScannerOpen(false)}
          onScan={(code) => {
            onChange(code, "barcode");
            lookupTemplateByBarcode(code);
            setIsBarcodeScannerOpen(false);
          }}
        />
      )}
    </>
  );
};

export default memo(ContentComponent);
